import app from 'flarum/forum/app';
/**
 * The hot topics, fetched once per page load.
 *
 * The hot area shows up in three places — the card grid on the index page,
 * the column beside the posts, the mobile bar — and they all show the same
 * topics. Fetching them once and sharing the result keeps that to a single
 * request per page load.
 */
let topics = null;
let pending = null;

/**
 * The topics, hottest first.
 *
 * The list is big enough to also answer "which topics are rising?", because
 * the rising block picks its five out of the same list.
 */
export function hotTopics() {
  if (topics) return Promise.resolve(topics);
  if (!pending) {
    pending = app.store.find('topics', {
      sort: '-heatScore',
      page: {
        limit: 50
      }
    }).then(found => {
      topics = found;
      return topics;
    }).catch(() => {
      topics = [];
      return topics;
    });
  }
  return pending;
}

/**
 * The topics as they are known right now.
 */
export function currentHotTopics() {
  return topics ?? [];
}

/**
 * The hot list in the order it should be shown.
 *
 * The order is the heat ranking until an admin curates the list (round 4
 * writes the curated order into the settings; until then `hotCurated` is
 * empty and the ranking stands in).
 *
 * A topic that is not in the fetched set (because it fell out of the top of
 * the ranking) is simply not shown — the list is a ranking with a hand-picked
 * order, not a second source of truth.
 */
export function orderedHotTopics(list, curated, limit) {
  if (!curated || !curated.length) return list.slice(0, limit);
  const byId = new Map(list.map(topic => [topic.id(), topic]));
  return curated.map(id => byId.get(String(id))).filter(topic => Boolean(topic)).slice(0, limit);
}
flarum.reg.add('ziiven-topics', 'forum/state/hotTopics', { hotTopics: hotTopics,currentHotTopics: currentHotTopics,orderedHotTopics: orderedHotTopics, });